import swaggerClient from "./../plugins/swagger-client";

export default class MaintainerService {
  retrieveMaintainers(parameters = {}) {
    return swaggerClient.swagger
      .then(client => {
        return client.apis.Maintainers.retrieveMaintainers(
          parameters,
          swaggerClient.buildRequestBody(),
          {}
        );
      })
      .then(response => {
        return response.body;
      })
      .catch(error => {
        return Promise.reject(error);
      });
  }

  retrieveMaintainer(maintainerId, administratorId) {
    return swaggerClient.swagger
      .then(client => {
        return client.apis.Maintainers.retrieveMaintainer(
          { maintainerId, administratorId },
          swaggerClient.buildRequestBody(),
          {}
        );
      })
      .then(response => {
        return response.body;
      })
      .catch(error => {
        return Promise.reject(error);
      });
  }

  retrieveAdminMaintainers(parameters = {}) {
    return swaggerClient.swagger
      .then(client => {
        return client.apis.Maintainers.retrieveAdminMaintainers(
          parameters,
          swaggerClient.buildRequestBody(),
          {}
        );
      })
      .then(response => {
        return response.body;
      })
      .catch(error => {
        return Promise.reject(error);
      });
  }

  updateMaintainer(maintainer) {
    return swaggerClient.swagger
      .then(client => {
        return client.apis.Maintainers.updateMaintainer(
          { maintainerId: maintainer.maintainerId },
          swaggerClient.buildRequestBody(maintainer),
          {}
        );
      })
      .then(response => {
        return response.body;
      })
      .catch(error => {
        return Promise.reject(error);
      });
  }

  addAdminMaintainer(maintainerId, administratorId) {
    return swaggerClient.swagger
      .then(client => {
        return client.apis.Maintainers.addAdminMaintainer(
          { maintainerId },
          swaggerClient.buildRequestBody({
            administratorId: administratorId
          }),
          {}
        );
      })
      .then(response => {
        return response.body;
      })
      .catch(error => {
        return Promise.reject(error);
      });
  }

  deleteAdminMaintainer(maintainerId) {
    return swaggerClient.swagger
      .then(client => {
        return client.apis.Maintainers.deleteAdminMaintainer(
          { maintainerId },
          swaggerClient.buildRequestBody(),
          {}
        );
      })
      .then(response => {
        return response.body;
      })
      .catch(error => {
        return Promise.reject(error);
      });
  }
}
